export default __webpack_public_path__ + "static/media/beauti-acedemy.c3b49b3a.png";